import { useEffect, useState } from 'react';
import { getTicketPaymentStatus } from '../../../services/customer/ticketServices';
import { useModal } from '../../contexts/modalsContext/modalsContext';

function UsePaymentStatus(id) {
  const [payment, setPayment] = useState({});
  const { setShowTicketPaymentStatus } = useModal();

  const fetchData = async () => {
    try {
      const res = await getTicketPaymentStatus(id);
      setPayment(res);
    } catch {
      setPayment({
        status: 'fail',
      });
    } finally {
      setShowTicketPaymentStatus(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return payment;
}

export default UsePaymentStatus;
